import React, { Component } from "react";
import { connect } from "react-redux";
import "./login.less";
import { login } from "../../actions";
import { Card, Form, Icon, Input, Button } from "antd";
import PropTypes from "prop-types";
const FormItem = Form.Item;
class Login extends Component {
     state = {
        iframeHeight: 600,
     }
  constructor() {
    super(...arguments);
    this.state = {
      info: {
        username: "",
        password: "",
        token: "",
      },
    };
  }
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { username, password } = values;
        if (username === "admin" && password === "admin") {
          let content = this.props.loginClick({
            ...values,
            token: "user_token",
          });
          console.log(content, 999);
          this.context.router.push("/");
        }
      }
    });
  };

  wireRegisterLinksInIframe = (iframe) => {
    if (!iframe) return
    try {
      const doc = iframe.contentDocument || iframe.contentWindow.document
      doc.querySelectorAll('button.btn-register, button.btn-register-main').forEach((btn) => {
        if (!/立即注册/.test((btn.textContent || '').trim())) return
        const a = doc.createElement('a')
        const pub = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
        a.href = pub ? `${pub}/register` : '/register'
        a.target = '_top'
        a.className = btn.className
        a.textContent = btn.textContent || '立即注册'
        Object.assign(a.style, {
          textDecoration: 'none',
          display: btn.classList.contains('btn-register-main') ? 'flex' : 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box',
        })
        btn.parentNode.replaceChild(a, btn)
      })
    } catch (err) {
      // cross-origin iframe
    }
  }

  componentDidMount() {
        this._onAffiliateIframeMessage = (e) => {
            const d = e.data
            if (!d || d.source !== 'login-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onAffiliateIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onAffiliateIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from affiliate.html
        }
    }
  render() {
    // const { getFieldDecorator } = this.props.form;
     const { iframeHeight } = this.state
    return (
         <div style={{ width: '100%' }}>
                <iframe
                    title="login-static"
                    src={`${process.env.PUBLIC_URL}/static/login/login.html`}
                    style={{ width: '100%', height: '100vh', border: 'none', display: 'block', overflow: 'hidden' }}
                    onLoad={(e) => {
                      this.syncIframeHeightFromContent(e.target)
                      this.wireRegisterLinksInIframe(e.target)
                    }}
                />
            </div>
    //   <div className="login">
    //     <div className="login-con">
    //       <Card title="欢迎登陆">
    //         <div className="form-con">
    //           <Form onSubmit={this.handleSubmit} className="login-form">
    //             <FormItem>
    //               {getFieldDecorator("username", {
    //                 rules: [{ required: true, message: "默认用户名admin!" }],
    //               })(
    //                 <Input
    //                   prefix={
    //                     <Icon
    //                       type="user"
    //                       style={{ color: "rgba(0,0,0,.25)" }}
    //                     />
    //                   }
    //                   placeholder="默认用户名admin!"
    //                 />,
    //               )}
    //             </FormItem>
    //             <FormItem>
    //               {getFieldDecorator("password", {
    //                 rules: [{ required: true, message: "默认密码admin!" }],
    //               })(
    //                 <Input
    //                   prefix={
    //                     <Icon
    //                       type="lock"
    //                       style={{ color: "rgba(0,0,0,.25)" }}
    //                     />
    //                   }
    //                   type="password"
    //                   placeholder="默认密码admin!"
    //                 />,
    //               )}
    //             </FormItem>
    //             <FormItem>
    //               {/*<a className="login-form-forgot" href="">忘记密码</a>*/}
    //               <Button
    //                 type="primary"
    //                 htmlType="submit"
    //                 className="login-form-button"
    //               >
    //                 登陆
    //               </Button>
    //             </FormItem>
    //           </Form>

    //           <p className="login-tip">react网站模板平台</p>
    //         </div>
    //       </Card>
    //       ,
    //     </div>
    //   </div>
    );
  }
}
const getLoginAction = (dispatch) => {
  return {
    loginClick: (info) => {
      return dispatch(login(info));
    },
  };
};

const getLoginState = (state) => {
  return {
    state: state,
  };
};
export default Form.create()(
  connect(
    getLoginState,
    getLoginAction,
  )(Login),
);
